import { useFormat } from 'helpers/hooks/useFormat';

const OrderNotFound: React.FC = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className="px-4 md:px-6 lg:px-11">
      <div className="border-l-4 border-red-500 bg-red-100 p-1 text-red-700" role="alert">
        <p className="font-bold">
          {formatMessage({ id: 'publicorder.notFound', defaultMessage: 'Ordine non trovato.' })}
        </p>
      </div>
    </div>
  );
};

export default OrderNotFound;
